<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col lg="12">
        <b-card>
          <div slot="header">
            <strong>Condición de Venta</strong>
          </div>
          <b-row>
            <b-col lg="6">
              <b-button type="primary" variant="primary" @click="agregarCondicion">
                <i class="fa fa-plus"></i> Agregar Condición de Venta
              </b-button>
            </b-col>
            <b-col lg="6">
              <b-form-group label label-for="filtroCondicion">
                <b-form-input
                  id="filtroCondicion"
                  type="text"
                  placeholder="Filtrar Condicion"
                  v-model="filters[0].value"
                ></b-form-input>
              </b-form-group>
            </b-col>
          </b-row>
          <br>
          <b-row>
            <b-col lg="12">
              <data-tables
                :data="data"
                :current-page.sync="pagina"
                :table-props="tableProps"
                :filters="filters"
                :page-size="10"
                :pagination-props="{ background: true, pageSizes: [10, 20, 50] }"
                layout="table"
              >
                <el-table-column
                  v-for="title in titles"
                  :min-width="title.minwidth"
                  :prop="title.prop"
                  :label="title.label"
                  :key="title.label"
                  sortable="custom"
                  :formatter="formatter"
                ></el-table-column>

                <el-table-column label="Acciones" min-width="100px">
                  <template slot-scope="scope">
                    <el-button
                      v-for="button in customButtonsForRow(scope.row)"
                      :key="button.name"
                      type="text"
                      @click="button.handler"
                    >
                      <i v-bind:class="button.icon"></i>
                      {{ button.name }}
                    </el-button>
                  </template>
                </el-table-column>
              </data-tables>
            </b-col>
          </b-row>
        </b-card>
      </b-col>
    </b-row>

    <editar-condicion ref="refEditarCondicion" @actualizaCondicion="buscar()"></editar-condicion>

    <b-modal
      title="Advertencia"
      cancel-title="Cancelar"
      ok-title="Desactivar"
      class="modal-warning"
      v-model="modalEliminarCondicion"
      @ok="eliminarCondicion();"
      @cancel="modalEliminarCondicion = false"
    >¿Está seguro que quiere desactivar esta condición?</b-modal>

    <b-modal
      title="Advertencia"
      cancel-title="Cancelar"
      ok-title="Activar"
      class="modal-warning"
      v-model="modalActivarCondicion"
      @ok="activarCondicion();"
      @cancel="modalActivarCondicion = false"
    >¿Está seguro que quiere activar este condición?</b-modal>
  </div>
</template>
<script>
import { Switch as cSwitch } from "@coreui/vue";
import axios from "axios";
import { tablasMixin } from "@/components/mixins/tablasMixin";
import apiCondicionVenta from "@/components/services/apiCondicionVenta";
import { globalesMixin } from "@/components/mixins/globalesMixin";
import EditarCondicion from "./EditarCondicion";

export default {
  name: "Condicion",
  mixins: [tablasMixin, globalesMixin],
  components: {
    cSwitch,
    EditarCondicion
  },
  data: function() {
    return {
      modalEliminarCondicion: false,
      modalActivarCondicion: false,
      modalAgregarCondicion: false,
      condicionSelected: null,
      busqueda: "",
      pagina: 1,
      paginaAnterior: 1,
      labelIcon: {
        dataOn: "\u2713",
        dataOff: "\u2715"
      },
      datosFormulario: [],
      data: [],
      titles: [
        {
          prop: "acvcodigo",
          label: "Código",
          align: "left",
          minwidth: "40"
        },
        {
          prop: "acvtipo",
          label: "Tipo",
          align: "left",
          minwidth: "80"
        },
        {
          prop: "acvdescrip",
          label: "Descripción",
          align: "left",
          minwidth: "300"
        },
        {
          prop: "acvusumodif",
          label: "Usuario Mod.",
          align: "left",
          minwidth: "60"
        },
        {
          prop: "acvfmodif",
          label: "Fecha Mod.",
          align: "left",
          minwidth: "60"
        },
        {
          prop: "desc_estado",
          label: "Estado",
          align: "left",
          minwidth: "60"
        }
      ],
      filters: [
        {
          prop: [
            "acvcodigo",
            "acvtipo",
            "acvdescrip",
            "acvusumodif",
            "acvfmodif",
            "acvestado"
          ],
          value: ""
        }
      ]
    };
  },
  methods: {
    customButtonsForRow(row) {
      if (row.acvestado === 0) {
        return [
          {
            name: " Activar",
            icon: "fa fa-plus",
            type: "success",
            handler: _ => {
              this.$session.start();
              this.modalActivarCondicion = true;
              this.condicionSelected = row.acvcodigo;
            }
          }
        ];
      } else {
        return [
          {
            name: " Modificar",
            icon: "fa fa-pencil",
            type: "primary",
            handler: _ => {
              this.$refs.refEditarCondicion.modalEditarCondicion = true;
              this.$refs.refEditarCondicion.visible = true;
              this.$refs.refEditarCondicion.obtenerCondicion(
                this.$session.get("mail"),
                this.$session.get("usuarioInterno"),
                row.acvcodigo,
                "MOD"
              );
            }
          },
          {
            name: " Desactivar",
            icon: "fa fa-trash",
            type: "danger",
            handler: _ => {
              this.$session.start();
              this.modalEliminarCondicion = true;
              this.condicionSelected = row.acvcodigo;
            }
          }
        ];
      }
    },
    buscar(p_acvcodigo) {
      this.$Progress.start();

      return apiCondicionVenta
        .buscar(
          this.$session.get("mail"),
          this.$session.get("usuarioInterno"),
          p_acvcodigo,
          "REC"
        )
        .then(response => {
          response.data = this.keysMinuscula(response.data);
          this.data = response.data.res;
          this.pagina = this.paginaAnterior;
          this.$router.push({ path: "CondicionVenta" });
          this.$Progress.finish();
        })
        .catch(error => {
          this.crearNotificacion("Error de sistema", error, "error");
        });
    },
    formatter(row, column) {
      if (column.property == "acvfmodif" && row[column.property]) {
        return this.$moment(row[column.property]).format("DD-MM-YYYY");
      } 
      else {
        return row[column.property];
      }
    },
    agregarCondicion() {
      this.$refs.refEditarCondicion.modalAgregarCondicion = true;
      this.$refs.refEditarCondicion.visible = true;
      this.$refs.refEditarCondicion.pre_insertar(
        this.$session.get("mail"),
        this.$session.get("usuarioInterno"),
        ""
      );
    },
    eliminarCondicion() {
      event.preventDefault();
      this.$Progress.start();
      return apiCondicionVenta
        .eliminar(
          this.$session.get("mail"),
          this.$session.get("usuarioInterno"),
          this.condicionSelected
        )
        .then(response => {
          this.mensajeToastr({
            title: response.data.festado.resultado.titulo,
            message: this.crearError(response.data.festado, "acvcodigo"),
            type: response.data.festado.resultado.estado,
            timeout: 6000
          });
          if (response.data.festado.resultado.estado != "error") {
            this.buscar("");
            this.modalEliminarCondicion = false;
          }
          this.$Progress.finish();
        })
        .catch(error => {
          this.crearNotificacion("Error de sistema", error, "error");
        });
    },
    activarCondicion() {
      event.preventDefault();
      this.$Progress.start();
      return apiCondicionVenta
        .activar(
          this.$session.get("mail"),
          this.$session.get("usuarioInterno"),
          this.condicionSelected
        )
        .then(response => {
          this.mensajeToastr({
            title: response.data.festado.resultado.titulo,
            message: this.crearError(response.data.festado, "acvcodigo"),
            type: response.data.festado.resultado.estado,
            timeout: 6000
          });
          if (response.data.festado.resultado.estado != "error") {
            this.buscar("");
            this.modalActivarCondicion = false;
          }
          this.$Progress.finish();
        })
        .catch(error => {
          this.crearNotificacion("Error de sistema", error, "error");
        });
    }
  },
  mounted() {
    this.pagina = Number(this.$route.query.pagina);
    this.buscar("");
  },
  watch: {
    pagina: function(nuevo, anterior) {
      this.paginaAnterior = anterior;
      this.$router.push({ path: "CondicionVenta" });
    }
  }
};
</script>
